export const FORM_BUILDER_OPTION_BLOCK_TYPES = new Set([
  'dropdown',
  'radio',
  'checkbox',
  'checkbox_group',
]);

export const FORM_BUILDER_DEFAULT_OPTIONS: Record<string, string[]> = {
  dropdown: ['Option 1', 'Option 2', 'Option 3'],
  radio: ['Option A', 'Option B'],
  checkbox: ['Check this box'],
  checkbox_group: ['Option 1', 'Option 2', 'Option 3'],
};

export function resolveFormBuilderBlockOptions(
  typeId: string,
  options?: string[],
): string[] | undefined {
  const cleaned = options?.map((item) => item.trim()).filter(Boolean);
  if (cleaned?.length) return cleaned;
  return FORM_BUILDER_DEFAULT_OPTIONS[typeId];
}
